// extracted by mini-css-extract-plugin
module.exports = {"profileInfo":"styles_profileInfo__2_giJ","actionProfile":"styles_actionProfile__2WCJV"};